import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaServiceRequest.less"
import typographyStyles from "AtomicComponents/Typography/Typography.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { Link } from "react-router-dom"
import {
  InputText,
  Space,
  InputCheckBox,
  A,
  Button,
  InputSelect,
  H3,
  H5,
  P,
  FormGroup,
  TickModalIcon,
  Content
} from "AtomicComponents"
import { AlertList, DealerSearch, InputDate } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { formSetDefaultValues, fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import dateHandler from 'AtomicUtils/dateHandler'
import MESSAGES from "AtomicConstants/MESSAGES"
import TIMES from "./TIMES"
import { DealerSearchBoxNZ } from "components"

class MyMazdaServiceRequest extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        odometer: {
          validations: {
            odometer: MESSAGES.ODOMETER_INVALID
          }
        },
        dealer: {
          validations: {
            required: MESSAGES.DEALERS_REQUIRED
          }
        },
        comments: {
          validations: {
          }
        },
        date: {
          validations: {
            required: MESSAGES.DATE_REQUIRED,
          }
        },
        dropOff: {
          validations: {
            required: MESSAGES.TIME_REQUIRED,
          }
        },
        pickUp: {
          validations: {
            required: MESSAGES.TIME_REQUIRED,
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null,
    }
  }

  componentDidMount() {
    formSetDefaultValues(this, { dropOff: "09:00 AM" })
    formSetDefaultValues(this, { pickUp: "12:00 PM" })
  }

  _handleSubmit = async (event) => {
    const { buttonText = "Request A Service" } = this.props
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { serviceRequestSubmissionApiEndPoint, service, serviceOptions, isComplementaryPage } = this.props
        const { form } = this.state

        const baseDescription =
          serviceOptions &&
          (isComplementaryPage
            ? serviceOptions.serviceItems.find(s => s.factoryCodeEntity.distance === 0)
            : service &&
            serviceOptions.serviceItems.filter(s => s.factoryCodeEntity.distance > 0)[
            service.activeServiceCodeIndex
            ])

        const additionalDescriptions = []
        serviceOptions &&
          service &&
          service.selectedAdditionalServices &&
          serviceOptions.serviceItems.forEach((item, index) => {
            Object.keys(service.selectedAdditionalServices).forEach(addtionalItemCode => {
              if (
                item.factoryCode === addtionalItemCode &&
                service.selectedAdditionalServices[addtionalItemCode]
              ) {
                additionalDescriptions.push(item)
              }
            })
          })

        let body = {
          optedIn: true,
          odometer: form.odometer.value,
          comments: form.comments.value,
          dealerLocation: form.dealer.value.id,
          dealerCode: form.dealer.value.dealerCode,
          preferredDate: form.date.value && new dateHandler(form.date.value).format('0D/0M/YYYY') || '',
          preferredDropOffTime: form.dropOff.value,
          preferredPickUpTime: form.pickUp.value,
          serviceOptions: baseDescription ? [baseDescription, ...additionalDescriptions] : null
        }

        await fetchAPI({
          method: "POST",
          url: serviceRequestSubmissionApiEndPoint,
          body: body
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg,
                loading: false
              })
            } else {
              // successful
              this.setState({
                loading: false,
                success: true
              }, () => {
                gtmHandler({
                  pageCategory: "MyMazda - Servicing",
                  pageAction: `Calculator Form - Clicked "${buttonText.toUpperCase()}"`
                })
              })
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  selectDealer = (dealer) => {
    // no search, use the selected dealer only for the radio inputs
    // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
    this.refs.dealerSearchComp.setState({
      dealers: [dealer],
      selected: dealer,
      loading: false
    })
  }

  render() {
    const {
      heading,
      description,
      privacyPolicyText,
      privacyPolicyUrl,
      buttonText = "Request A Service",
      contactHeading,
      initialLocations,
      dealerApiEndPoint,
      isComplementaryPage,
      contactDetails
    } = this.props
    const { loading, form, success, errorMessage } = this.state

    if (success) {
      return (
        <div className={classnames({ [styles.MyMazdaServiceRequest]: true })}>
          <div className={classnames({ [styles.MyMazdaServiceRequestForm]: true })}>
            <FormGroup>
              <TickModalIcon style={{ width: "2.25em", height: "2.25em", margin: "0 auto" }} />
              <Space />
              <H3 withDetails>Service requested</H3>
              <P>Your dealer will get in touch with you to confirm your service request.</P>
            </FormGroup>
          </div>
        </div>
      )
    }

    return (
      <div className={classnames({
        [styles.MyMazdaServiceRequest]: true
      })}>
        <H3 withDetails>{heading}</H3>
        <Content xmlString={description} />
        <div className={classnames({
          [styles.MyMazdaServiceRequestForm]: true
        })}>
          <form method="POST" onSubmit={this._handleSubmit}>
            <FormGroup>
              <InputDate
                name="date"
                label="Preferred Date"
                {...fromLinkInputs(this, "date")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda - Servicing",
                    pageAction: "Request A Service Form - Entered \"DATE\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputSelect
                name="dropOff"
                label="Preferred Drop Off Time"
                options={TIMES}
                {...fromLinkInputs(this, "dropOff")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda - Servicing",
                    pageAction: `Calculator Form - Selected "DROP OFF TIME" - "${form.dropOff.value}"`
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputSelect
                name="pickUp"
                label="Preferred Pick Up Time"
                options={TIMES}
                {...fromLinkInputs(this, "pickUp")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda - Servicing",
                    pageAction: `Calculator Form - Selected "PICK UP TIME" - "${form.pickUp.value}"`
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="odometer"
                label="Odometer"
                {...fromLinkInputs(this, "odometer")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda - Servicing",
                    pageAction: `Calculator Form - Entered "${form.odometer.value}"`
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="comments"
                label="Tell us your enquiry"
                {...fromLinkInputs(this, "comments")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "MyMazda - Servicing",
                    pageAction: "Request A Service Form - Entered \"ENQUIRY\""
                  })
                }}
              />
            </FormGroup>

            <H5 textAlign="center">Find a dealer</H5>
            <P>Select your region and we'll give you a list of your local Mazda Dealerships.</P>

            <DealerSearchBoxNZ
                searchType="SERVICE"
                noMap={true}
                selectDealerVariant={true}
                selectDealer={this.selectDealer}
              />

            <FormGroup>
              <DealerSearch
                endpoint={dealerApiEndPoint}
                disabled={!initialLocations}
                type="Service"
                name="dealer"
                postcode={initialLocations && initialLocations[0] && initialLocations[0].postCode}
                ref="dealerSearchComp"
                {...fromLinkInputs(this, "dealer")} />
            </FormGroup>

            <FormGroup center>
              <H5>
                {contactHeading || "Your Contact Details"}
              </H5>
            </FormGroup>

            <FormGroup>
              <P>
                {contactDetails.name}
                <br />
                {contactDetails.email}
                <br />
                {contactDetails.phone}
              </P>
              <P>To update your details, visit the{" "}
                <Link
                  to={contactDetails.manageAccountPageUrl}
                  className={classnames({
                    [typographyStyles.blackColor]: true
                  })}>
                  manage account
                </Link>{" "}
                page.
              </P>
              <P>
                Your details will be sent to{" "}
                <b>{form.dealer.value ? form.dealer.value.name : "your dealer"}</b> and they will contact you
                to confirm the booking
              </P>

            </FormGroup>

            <FormGroup>
              <Space />
              <InputCheckBox
                name="privacy"
                label={
                  <span>
                    {privacyPolicyText}{" "}
                    <A
                      href={privacyPolicyUrl}
                      onClick={() => {
                        gtmHandler({
                          pageCategory: "MyMazda - Servicing",
                          pageAction: "Request A Service Form - Clicked \"PRIVACYPOLICY\""
                        })
                      }}
                      external>
                      <nobr>Privacy Policy</nobr>
                    </A>
                  </span>
                }
                {...fromLinkInputs(this, "privacy", () => {
                  gtmHandler({
                    pageCategory: "MyMazda - Servicing",
                    pageAction: "Request A Service Form - Checked \"PRIVACYPOLICY\""
                  })
                })}
              />
            </FormGroup>

            <FormGroup>
              {errorMessage &&
                <AlertList data={errorMessage} />
              }
              <Button
                styleName="black"
                loading={loading}
                fullWidth
                {...formLinkSubmit(this, this._handleSubmit)}
              >
                {isComplementaryPage ? "Request Inspection" : buttonText}
              </Button>
            </FormGroup>

          </form>
        </div>
      </div>
    )
  }
}


export default MyMazdaServiceRequest




// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaServiceRequest/MyMazdaServiceRequest.jsx